"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FooterNavigation =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(FooterNavigation, _React$PureComponent);

  function FooterNavigation(props) {
    var _this;

    _classCallCheck(this, FooterNavigation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FooterNavigation).call(this, props));
    _this.id = props.id || (0, _unique.default)();
    return _this;
  }

  _createClass(FooterNavigation, [{
    key: "render",
    value: function render() {
      var id = this.id;
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$ariaLabel = _this$props.ariaLabel,
          ariaLabel = _this$props$ariaLabel === void 0 ? 'page footer' : _this$props$ariaLabel;
      return _react.default.createElement("nav", {
        "aria-labelledby": id,
        className: "co-footer__nav"
      }, _react.default.createElement("h2", {
        id: id,
        className: "co--visually-hidden"
      }, ariaLabel), _react.default.createElement("ul", {
        className: "co-footer__links"
      }, children));
    }
  }]);

  return FooterNavigation;
}(_react.default.PureComponent);

FooterNavigation.propTypes = {
  /** {---} Sequence of: @@<Footer.Link>@@ (required, min: 1) */
  children: _propTypes.any.isRequired
};
FooterNavigation.displayName = 'Footer.Navigation';
var _default = FooterNavigation;
exports.default = _default;
FooterNavigation.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Footer.Navigation",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<Footer.Link>@@ (required, min: 1)"
    }
  }
};